module.exports = __webpack_public_path__ + "img/good-none.327bf676.png";